import { httpClient } from "@bw/shared/api";
import type { Schema } from "@bw/shared/types/generated";

type RewardsSummaryWire = Schema["FacilityRewardsSummary"];
export type RewardsSummary = Omit<
  RewardsSummaryWire,
  "grants" | "referral_claims" | "referral_codes"
> & {
  grants: NonNullable<RewardsSummaryWire["grants"]>;
  referral_claims: NonNullable<RewardsSummaryWire["referral_claims"]>;
  referral_codes: NonNullable<RewardsSummaryWire["referral_codes"]>;
};
export type ReferralCode = Schema["FacilityReferralCodeResponse"];
export type ReferralClaim = Schema["FacilityReferralClaimResponse"];

export const rewardsApi = {
  mine: async (): Promise<RewardsSummary> => {
    const response = await httpClient.get<RewardsSummaryWire>("/rewards/me");
    return {
      ...response,
      grants: response.grants ?? [],
      referral_claims: response.referral_claims ?? [],
      referral_codes: response.referral_codes ?? [],
    };
  },
  referralCode: (campaignId: string) =>
    httpClient.post<ReferralCode>(
      `/rewards/referrals/${encodeURIComponent(campaignId)}/code`,
      {},
    ),
  claimReferral: (code: string) =>
    httpClient.post<ReferralClaim>("/rewards/referrals/claim", { code }),
};
